import PropTypes from 'prop-types';

export const PTStep = {
  name: PropTypes.string.isRequired,
  completed: PropTypes.bool.isRequired,
  clickable: PropTypes.bool.isRequired,
};

export const PTStepIndicator = {
  steps: PropTypes.arrayOf(PropTypes.shape(PTStep)).isRequired,
  currentStep: PropTypes.shape(PTStep),
  onChange: PropTypes.func.isRequired,
};
